import {
  GET_CATEGORY_NEWS,
  POST_CATEGORY_NEWS,
  PUT_CATEGORY_NEWS,
  DELETE_CATEGORY_NEWS,
  GET_SUB_CATEGORY_NEWS,
  POST_SUB_CATEGORY_NEWS,
  PUT_SUB_CATEGORY_NEWS,
  DELETE_SUB_CATEGORY_NEWS
} from '../type'

const initialState = {
  listCategoryNews: [],
  listSubCategoryNews: []
}

const categoryNews = (state = initialState, action) => {
  switch (action.type) {
    case GET_CATEGORY_NEWS:
      return {
        ...state,
        listCategoryNews: action.data
      }
    case POST_CATEGORY_NEWS:
      return {
        ...state,
        listCategoryNews: [...state.listCategoryNews, action.data]
      }
    case PUT_CATEGORY_NEWS:
      return {
        ...state,
        listCategoryNews: state.listCategoryNews.map(
          (item) => item._id === action.data._id ? item = action.data : item
        )
      }
    case DELETE_CATEGORY_NEWS:
      return {
        ...state,
        listCategoryNews: state.listCategoryNews.filter(
          (item) => item._id !== action.data._id
        )
      }
    case GET_SUB_CATEGORY_NEWS:
      return {
        ...state,
        listSubCategoryNews: action.data
      }
    case POST_SUB_CATEGORY_NEWS:
      return {
        ...state,
        listSubCategoryNews: [...state.listSubCategoryNews, action.data]
      }
    case PUT_SUB_CATEGORY_NEWS:
      return {
        ...state,
        listSubCategoryNews: state.listSubCategoryNews.map(
          (item) => item._id === action.data._id ? item = action.data : item
        )
      }
    case DELETE_SUB_CATEGORY_NEWS:
      return {
        ...state,
        listSubCategoryNews: state.listSubCategoryNews.filter(
          (item) => item._id !== action.data._id
        )
      }
    default:
      return state
  }
}

export default categoryNews